<template>
  <customModal :containermd="true" @closeModal="closeModal">
    <template #title>
      {{ isEditMode ? "Edit Checklist" : "Add Checklist" }}
    </template>

    <template #body>
      <div class="row">

        <div class="col-12 mb-3">
          <label class="form-label">
            Title
            <sup class="text-danger"><i class="fa fa-asterisk imp"></i></sup>
          </label>
          <input type="text" class="form-control" v-model="task.title" placeholder="Enter task title" />
          <small class="text-danger" v-if="errors.title">{{ errors.title }}</small>
        </div>

        <div class="col-12 mb-2 d-flex justify-content-between align-items-center">
          <h6 class="mb-0">Questions</h6>

          <div class="d-flex gap-3 align-items-center">
            <!-- Add Question -->
            <div class="position-relative cursor-pointer">
              <img src="../../assets/img/create.png" width="17" height="17" alt="Add Question" @click="addQuestion()" />
              <div class="tool-tip">
                {{ $t("navigations.add question") }}
              </div>  
            </div>

            <!-- Delete All Questions -->
            <div class="position-relative cursor-pointer" v-if="isEditMode && task.questions.length">
              <img src="../../assets/img/delete_doc.png" width="17" height="17" alt="Delete All Questions" @click="deleteAllQuestions()" />
              <div class="tool-tip">
                Delete all questions
              </div>
            </div>
          </div>
        </div>



        <div class="col-12">
          <table class="table table-bordered align-middle">
            <thead class="table-light">
              <tr>
                <th style="width: 5%">#</th>
                <th>Question</th>
                <th class="text-center">Edit</th>
                <th class="text-center" style="width: 10%">Delete</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="!task.questions.length">
                <td colspan="4" class="text-center text-muted">
                  No questions added
                </td>
              </tr>

              <tr v-for="(q, index) in task.questions" :key="q.id">
                <td>{{ index + 1 }}</td>

                <td>
                  <input v-if="editingQuestionId === q.id" type="text" class="form-control" v-model="q.text" />
                  <span v-else>
                    {{ q.text }}
                  </span>
                </td>

                <td class="text-center">
                  <template v-if="q.isNew"></template>

                  <i v-else-if="editingQuestionId !== q.id" class="fa fa-edit edit-delete" style="color:#a13b7c"
                    @click="editQuestion(q)"></i>

                  <div v-else class="d-flex justify-content-center gap-2">
                    <i class="fa fa-save edit-delete cursor-pointer" title="Save" @click="saveQuestion(q)"></i>

                    <i class="fa fa-times text-danger cursor-pointer" title="Cancel" @click="cancelEditQuestion()"></i>
                  </div>
                </td>


                <td class="text-center">
                  <i class="fa fa-trash edit-delete" style="color:#a13b7c" @click="removeQuestion(index)"></i>
                </td>

              </tr>
            </tbody>

          </table>
        </div>

        <div class="col-12 text-end mt-3">
          <button class="save_btn px-4 py-1" @click="saveTask">
            {{ isEditMode ? "Update" : "Save" }}
          </button>
        </div>

      </div>
    </template>
  </customModal>
</template>
<script src="./TaskAddEditModal.js"></script>
<style scoped>
.text-danger {
  color: rgb(255, 21, 21);
}

.cursor-pointer {
  cursor: pointer;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

.table td {
  vertical-align: middle;
}

.save_btn {
  background-color: #1ab394;
  border: none;
  color: #fff;
  border-radius: 4px;
}

.save_btn:hover {
  background-color: #18a689;
}
</style>
